/**
 * Preview-only entry to the read-only Git branch map.
 * Production hostnames never show the menu, even if this build is opened there.
 */

const PRODUCTION_HOSTS = new Set([
  "app.nexorasystems.ca",
  "www.nexorasystems.ca",
  "voice-intake-app.vercel.app",
  "crewpilot-app.vercel.app",
  "crewpilot-app-midnight-slider-s-projects.vercel.app",
  "crewpilot-app-git-master-midnight-slider-s-projects.vercel.app",
]);

export const BRANCH_MAP_HREF = "/branch-map/index.html";

export const GIT_BRANCH_MAP_NAV_ITEM = Object.freeze({
  id: "git_branch_map",
  label: "Git Branch Map",
  kicker: "Developer Tools",
  group: "Internal Tools",
  icon: "🗺️",
  href: BRANCH_MAP_HREF,
});

export function isBranchMapPreviewHost(hostname) {
  const host =
    hostname ??
    (typeof window !== "undefined" ? window.location.hostname : "");
  if (!host) return false;
  if (host === "localhost" || host === "127.0.0.1") return true;
  if (PRODUCTION_HOSTS.has(host)) return false;
  return host.endsWith(".vercel.app");
}

export function openBranchMap() {
  // The app service worker serves the CrewPilot shell for extensionless
  // navigations such as /branch-map/. The map file itself is left alone.
  window.location.assign(BRANCH_MAP_HREF);
}
